import { render, staticRenderFns } from "./PersonBioRow.vue?vue&type=template&id=2ab45030&scoped=true"
import script from "./PersonBioRow.vue?vue&type=script&lang=js"
export * from "./PersonBioRow.vue?vue&type=script&lang=js"
import style0 from "./PersonBioRow.vue?vue&type=style&index=0&id=2ab45030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab45030",
  null
  
)

export default component.exports